import { Box, useTheme } from "@mui/material";

export const BasicContentContainer = ({ children, sx }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        border: "1px solid #D4D4D7",
        borderRadius: "10px",
        marginTop: theme.spacing(3),
        position: "relative",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
export default BasicContentContainer;
